module.exports = __webpack_public_path__ + "img/free@2x.639acc96.png";